module.exports = __webpack_public_path__ + "img/flkjyy_banner_img.0c402ae4.png";